import React from "react";
import pickloadicon from "../../images/pickloadicon.png";
import facebook from "../../images/facebook.png";
import instagram from "../../images/instagram.png";
import youtube from "../../images/youtube.png";
import twitter from "../../images/twitter.png";
import tiktok from "../../images/tiktok.png";

const Footer = () => {
  const year = new Date().getFullYear();

  const socials = [
    { icon: youtube, link: "https://www.youtube.com/@pickloadlogistics7714?sub_confirmation=1" },
    { icon: instagram, link: "https://www.instagram.com/pickload.logistics" },
    { icon: tiktok, link: "https://www.tiktok.com/@pickload.logistics" },
    { icon: facebook, link: "https://web.facebook.com/profile.php?id=100077184559128" },
    { icon: twitter, link: "https://x.com/pickload" },
  ];

  return (
    <footer style={{ backgroundColor: "rgba(5, 41, 9, 1)" }} className="mt-20">
      <div className="max-w-6xl mx-auto px-6 py-14">

        {/* TOP GRID */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">

          {/* BRAND */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <img src={pickloadicon} alt="logo" className="w-10 h-10" />
              <div>
                <h3 className="text-lg font-bold text-white">PICKLOAD</h3>
                <p className="text-xs text-green-200 tracking-wide">
                  MAKING LIFE EASIER
                </p>
              </div>
            </div>

            <p className="text-sm text-gray-200 leading-relaxed">
              Pickload connects buyers, sellers, and delivery agents in a
              seamless logistics ecosystem. Fast, secure, and reliable delivery
              services for everyone.
            </p>
          </div>

          {/* LINKS */}
          <div>
            <h4 className="font-semibold text-white mb-4">Quick Links</h4>
            <div className="flex flex-col gap-2 text-sm">
              <a className="text-gray-200 hover:text-white transition" href="/">
                Home
              </a>
              <a className="text-gray-200 hover:text-white transition" href="/faqs">
                FAQs
              </a>
            </div>
          </div>

          {/* LEGAL */}
          <div>
            <h4 className="font-semibold text-white mb-4">Legal</h4>
            <div className="flex flex-col gap-2 text-sm">
              <a className="text-gray-200 hover:text-white transition" href="/privacy">
                Privacy Policy
              </a>
              <a className="text-gray-200 hover:text-white transition" href="/Termsandconditions">
                Terms & Conditions
              </a>
            </div>
          </div>

          {/* CONTACT */}
          <div>
            <h4 className="font-semibold text-white mb-4">Contact</h4>

            <div className="text-sm text-gray-200 space-y-1">
              <p>+234 916 193 6446</p>
              <p>+234 902 210 6633</p>
              <p>support@pickload.ng</p>
            </div>

            {/* SOCIALS */}
            <div className="flex items-center gap-3 mt-5">
              {socials.map((s, i) => (
                <a
                  key={i}
                  href={s.link}
                  target="_blank"
                  rel="noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition transform hover:scale-110"
                >
                  <img src={s.icon} alt="social" className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* BOTTOM */}
        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-sm text-gray-300">
            © {year} Pickload. All rights reserved.
          </p>

          <p className="text-xs text-gray-400">
            Built with speed • trust • reliability
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;